import { isKnownPageView } from '../shared/page-views.js';

const ENDPOINT = '/api/views';
const LOCAL_DEDUPE_MS = 2_000;
let _lastKey = null;
let _lastSentAt = 0;

/**
 * Record one rendered user-facing route. This helper intentionally keeps no
 * persistent anonymous identifier: anonymous views count toward total views,
 * but uniqueness is available only for signed-in accounts.
 */
export function trackPageView(page, { subId = null } = {}) {
  try {
    if (!isKnownPageView(page)) return;

    const normalizedSubId = typeof subId === 'string' && subId ? subId : null;
    const key = `${page}:${normalizedSubId || ''}`;
    const now = Date.now();
    if (_lastKey === key && now - _lastSentAt < LOCAL_DEDUPE_MS) return;
    _lastKey = key;
    _lastSentAt = now;

    fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ page, sub_id: normalizedSubId }),
      keepalive: true,
    }).catch(() => { /* analytics must never break navigation */ });
  } catch {
    /* analytics must never break navigation */
  }
}

export function _resetPageViewClientState() {
  _lastKey = null;
  _lastSentAt = 0;
}
